import React from 'react'
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom'
import './App.css'
import Home from './pages/Home'
import Windchill from './pages/Windchill'
import Prostep from './pages/Prostep'
import BuildInfoFooter from './components/BuildInfoFooter'
import Config from './utils/config'
import PluginPage from './features/plugin/pages/PluginPage'

function AppLayout({ children }: { children: React.ReactNode }) {
  const location = useLocation()
  const isHomePage = location.pathname === '/'

  const inner = isHomePage ? (
    <div className="App">
      <div className="container">{children}</div>
    </div>
  ) : (
    <div className="standalone-page">{children}</div>
  )

  return (
    <>
      {inner}
      <BuildInfoFooter />
    </>
  )
}

function App(): JSX.Element {
  const basePath = (Config.get('basePath') as string) || '/'
  return (
    <Router basename={basePath}>
      <AppLayout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/windchill" element={<Windchill />} />
          <Route path="/prostep" element={<Prostep />} />
          <Route path="/plugin" element={<PluginPage />} />
        </Routes>
      </AppLayout>
    </Router>
  )
}

export default App
